import { render, staticRenderFns } from "./hotelInquiryDetails.vue?vue&type=template&id=50cb32d2&"
import script from "./hotelInquiryDetails.vue?vue&type=script&lang=js&"
export * from "./hotelInquiryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports